export default "__VITE_ASSET__Clein5LJ__"